import { FaCheckCircle } from 'react-icons/fa'
import { Link } from 'react-router-dom'

const SuccessStep = () => {
    return (
        <div className="flex flex-col items-center justify-center w-full rounded">
            <FaCheckCircle className="text-green-1 text-6xl mb-4" />
            <h2 className="text-green-600 text-xl font-bold mb-4">
                عملیات با موفقیت انجام شد!
            </h2>
            <p className="text-justify leading-7 mb-5 p-3 shadow-sm border bg-green-2 rounded">
                <span className="block">کاربر گرامی:</span>
                در صورتی که گواهی امضا را از امضامی دریافت نکرده اید٬ ابتدا
                اقدام به دریافت گواهی امضا کرده
            </p>
            <Link to="/promissory/sign-details">
                <button className="bg-green-1 text-white  py-2 px-4 rounded focus:outline-none focus:shadow-outline">
                    امضای سفته الکترونیک
                </button>
            </Link>
        </div>
    )
}

export default SuccessStep
